import { api } from "@/utils/api";

let linksController = new AbortController();
const restartLinksController = () => {
  linksController = new AbortController();
};

let geomapController = new AbortController();
const restartGeomapController = () => {
  geomapController = new AbortController();
};

const getLinksByLocation = async (locationId) => {
  try {
    restartLinksController();
    const response = await api.get(`links/locations/${locationId}`, {
      signal: linksController.signal,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getLinksMinify = async (locationId) => {
  try {
    restartLinksController();
    const response = await api.get(`links/locations/${locationId}/minify`, {
      signal: linksController.signal,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getGeomap = async (locationId) => {
  try {
    restartGeomapController();
    const response = await api.get(`geomap/locations/${locationId}`, {
      signal: geomapController.signal,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export { getLinksByLocation, getLinksMinify, getGeomap };
